module.exports = __webpack_public_path__ + "static/media/10.472ce556.mp3";